import React from 'react';
import {withTranslation} from 'react-i18next';
import { t } from 'i18next';

function Loader() {
    return (
        <div id='cover-spin-container'>
            <i id='cover-spin' class='fa fa-spinner fa-spin fa-3x fa-fw'></i>
            <div id='cover-spin-text'>
                <p> {t('global.loader')} </p>
            </div>
        </div>
    );
}

export default withTranslation()(Loader);
